export default __webpack_public_path__ + "static/media/2014.485d4028.png";